import store from '@/app/store';
import { Ref, computed, watch } from '@vue/composition-api';
import { is } from 'ramda';

export function useAvailableWorkflowModels(
    id: Ref<string> | string,
    isOnPremise: Ref<boolean>,
    usesDataProviderDataSpace: Ref<boolean>,
    immediate = false,
) {
    const workflowId = computed(() => (is(String, id) ? id : id.value));
    const models = computed(() => store.getters.pipelineDesigner.availableModels || []);
    const loading = computed(() => store.getters.pipelineDesigner.isLoadingModels);

    const usage = computed(() => {
        return isOnPremise.value
            ? usesDataProviderDataSpace.value
                ? 'use-on-premise-provider'
                : 'use-on-premise-recipient'
            : 'use-in-cloud';
    });

    const refetch = async () => {
        if (usage.value) store.dispatch.pipelineDesigner.loadAvailableModels({ force: true, usage: usage.value });
    };

    watch(
        () => workflowId.value,
        (newId: string, oldId: string | undefined) => {
            if (newId !== oldId && usage.value)
                store.dispatch.pipelineDesigner.loadAvailableModels({ force: false, usage: usage.value });
        },
        { immediate },
    );
    return { models, loading, refetch };
}
